import { useSearchParams } from 'react-router-dom';

const PostEditor = () => {
  const [searchParams] = useSearchParams();
  
  return (
    <div className="flex flex-col text-text-primary">
      <div className="p-4 lg:p-8">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-2xl lg:text-4xl font-medium text-primary text-left lg:text-center lg:mb-12">
            Welcome to{' '}
            {searchParams.get('name') === 'linkedIn' ? 'LinkedIn' : 'X'} post
            generator, enter details to generate viral worthy content in seconds.
          </h1>

          {/* Image only shows on desktop */}
          <div className="hidden lg:block mt-6 mx-auto w-3/4">
            <img
              src="/linkedingen.png"
              alt="Placeholder"
              className="w-full h-[360px] rounded-lg"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostEditor;
